import type { CalcStep } from "@/lib/calc/steps";

/** "How this was calculated": the ordered working under a result. Presentational; the steps come from the calculator. */
export function CalcSteps({ steps, title = "How this was calculated" }: { steps: CalcStep[]; title?: string }) {
  if (steps.length === 0) return null;
  return (
    <section aria-label={title} className="rounded-xl border bg-card p-4" data-testid="calc-steps">
      <details>
        <summary className="cursor-pointer text-sm font-semibold">{title}</summary>
        <ol className="mt-3 space-y-3 text-sm">
          {steps.map((s, i) => (
            <li key={`${i}-${s.label}`} data-testid="calc-step">
              <p className="font-medium">{i + 1}. {s.label}</p>
              <p className="text-muted-foreground">{s.formula}</p>
              {Object.keys(s.inputs).length > 0 && (
                <p className="text-muted-foreground">Using {Object.entries(s.inputs).map(([k, v]) => `${k} = ${v}`).join("; ")}</p>
              )}
              <p>Result: <strong>{s.result}</strong></p>
            </li>
          ))}
        </ol>
      </details>
    </section>
  );
}
